import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AlertService } from '../../shared/alert/alert.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { TermIdEnum } from '../../shared/ontology/model/termid.enum';
import { GermplasmListColumnCategory } from '../../shared/germplasm-list/model/germplasm-list-column-category.type';
import { ColumnLabels } from '../germplasm-search.component';
import { VIEW_NAMES_PERMISSION, VIEW_PEDIGREE_INFORMATION_PERMISSION } from '../../shared/auth/permissions';
import { Principal } from '../../shared';

@Component({
    selector: 'jhi-germplasm-columns',
    templateUrl: './germplasm-columns.component.html',
    styleUrls: [
        './germplasm-columns.component.scss'
    ]
})
export class GermplasmColumnsComponent implements OnInit {
    @Output() columnsSelectedEvent = new EventEmitter<GermplasmColumnModel[]>();

    @Input() hiddenColumns: any;

    @ViewChild('columnsDropdown', { static: true }) columnsDropdown: NgbDropdown;

    TermIdEnum = TermIdEnum;

    staticColumns: GermplasmColumnModel[] = [];

    namesPermissionRequired = [ColumnLabels.NAMES, ColumnLabels.CROSS, ColumnLabels['PREFERRED NAME'],
        ColumnLabels['CROSS-FEMALE PREFERRED NAME'], ColumnLabels['CROSS-MALE PREFERRED NAME'], ColumnLabels['GROUP SOURCE'],
        ColumnLabels['IMMEDIATE SOURCE']];

    pedigreeInfoPermissionRequired = [ColumnLabels.CROSS, ColumnLabels['CROSS-FEMALE PREFERRED NAME'],
        ColumnLabels['CROSS-MALE PREFERRED NAME'], ColumnLabels['GROUP SOURCE'], ColumnLabels['IMMEDIATE SOURCE'],
        ColumnLabels['FGID'], ColumnLabels['MGID'], ColumnLabels['GROUP SOURCE GID'], ColumnLabels['IMMEDIATE SOURCE GID']];

    constructor(private alertService: AlertService,
                private principal: Principal) {
    }

    ngOnInit(): void {
    }

    load() {
        this.staticColumns = [];
        this.generateColumnsList();
    }

    dropdownToggle() {
        if (this.columnsDropdown._open) {
            this.load();
        }
    }

    apply() {
        this.columnsDropdown.close();
        this.columnsSelectedEvent.emit(this.staticColumns);
    }

    onSearchColumn(evt: any) {
        const searchString = evt.target.value.toLowerCase();
        if (searchString) {
            this.filterColumns(this.staticColumns, searchString);
        } else {
            this.resetColumns();
        }
    }

    checkAreColumnsVisible(columns: GermplasmColumnModel[]): boolean {
        return columns.filter((column: GermplasmColumnModel) => column.visible).length > 0;
    }

    private filterColumns(columns: GermplasmColumnModel[], searchString: string) {
        columns.forEach((column: GermplasmColumnModel) => {
            if (!column.colName.toLowerCase().includes(searchString)) {
                column.visible = false;
            }
        });
    }

    private generateColumnsList() {
        let id = 1;
        Object.keys(ColumnLabels).forEach((column) => {
            if ((this.namesPermissionRequired.includes(ColumnLabels[column]) && !this.principal.hasAnyAuthorityDirect(VIEW_NAMES_PERMISSION))
                || (this.pedigreeInfoPermissionRequired.includes(ColumnLabels[column]) && !this.principal.hasAnyAuthorityDirect(VIEW_PEDIGREE_INFORMATION_PERMISSION))) {
                return;
            }
            this.staticColumns.push(new GermplasmColumnModel(id, column, ColumnsLabelID[column], !this.hiddenColumns[ColumnLabels[column]]));
            id++;
        });
        this.resetColumns();
    }

    private resetColumns() {
        this.staticColumns.forEach((column: GermplasmColumnModel) => column.visible = true);
    }

}

export class GermplasmColumnModel {

    constructor(
        public id: number,
        public colName: string,
        public colLabel: string,
        public selected: boolean,
        public typeId?: number,
        public category = GermplasmListColumnCategory.STATIC,
        public visible = true) {
    }

}

export enum ColumnsLabelID {
    'GID' = 'gid',
    'GERMPLASM UUID' = 'germplasmUUID',
    'GROUP ID' = 'groupId',
    'NAMES' = 'names',
    'AVAILABLE' = 'availableBalance',
    'LOT_UNITS' = 'unit',
    'LOTS' = 'lotCount',
    'CROSS' = 'pedigreeString',
    'PREFERRED ID' = 'germplasmPreferredId',
    'PREFERRED NAME' = 'germplasmPreferredName',
    'GERMPLASM DATE' = 'germplasmDate',
    'LOCATIONS' = 'locationName',
    'METHOD NAME' = 'methodName',
    'METHOD ABBREV' = 'methodCode',
    'METHOD NUMBER' = 'methodNumber',
    'METHOD GROUP' = 'methodGroup',
    'FGID' = 'femaleParentGID',
    'CROSS-FEMALE PREFERRED NAME' = 'femaleParentPreferredName',
    'MGID' = 'maleParentGID',
    'CROSS-MALE PREFERRED NAME' = 'maleParentPreferredName',
    'GROUP SOURCE GID' = 'groupSourceGID',
    'GROUP SOURCE' = 'groupSourcePreferredName',
    'IMMEDIATE SOURCE GID' = 'immediateSourceGID',
    'IMMEDIATE SOURCE' = 'immediateSourceName',
}
